<div class="switcher auto-bid-switcher" [ngClass]="{'checked': isChecked}">
  <div class="switch-button">
    <input [checked]="isChecked" [value]="isChecked" (change)="changeType()" id="bidTypeCheckbox" class="switch-button-checkbox" type="checkbox">
    <label class="switch-button-label" for="bidTypeCheckbox">
      <span class="switch-button-label-span">Bid</span>
    </label>
  </div>
</div>
